<p class="label">{{ 'company.payment_remarks.payment_remarks' | translate }}</p>

@if (watchlistUuid(); as uuid) {
  <p class="text-muted">
    {{ enableMessage() | translate }}
  </p>
  @if (sensitiveDataAccessEntityUuid$ | async; as sensitiveDataWatchlistAccessEntityUuid) {
    <button
      type="button"
      class="btn btn-secondary"
      (click)="openTogglePaymentRemarksModal('disable', 'watchlist', sensitiveDataWatchlistAccessEntityUuid)">
      {{ 'company.payment_remarks.payment_remarks_disable_button' | translate }}
    </button>
  } @else {
    <button
      id="watchlist-payment-remarks"
      type="button"
      class="btn btn-primary"
      (click)="openTogglePaymentRemarksModal('enable', 'watchlist', uuid)">
      {{ 'company.payment_remarks.payment_remarks_enable_button' | translate }}
    </button>
  }
}

@if (companyUuid(); as uuid) {
  <p class="text-muted">
    {{ enableMessage() | translate }}
  </p>
  @if (sensitiveDataAccessEntityUuid$ | async; as sensitiveDataCompanyAccessEntityUuid) {
    <button
      type="button"
      class="btn btn-secondary"
      (click)="openTogglePaymentRemarksModal('disable', 'company', sensitiveDataCompanyAccessEntityUuid)">
      {{ 'company.payment_remarks.payment_remarks_disable_button' | translate }}
    </button>
  } @else {
    <button
      id="company-payment-remarks"
      type="button"
      class="btn btn-primary"
      (click)="openTogglePaymentRemarksModal('enable', 'company', uuid)">
      {{ 'company.payment_remarks.payment_remarks_enable_button' | translate }}
    </button>
  }
}
